var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-sm"},[_c('div',{staticClass:"alert-sm-icon mr-2"},[_c('v-icon',{attrs:{"size":"16"}},[_vm._v("$infoCircle")])],1),_c('div',{staticClass:"alert-sm-text text--gray-darken1"},[_c('span',{staticClass:"p-sm"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }